import EmailExportHtml    from '../../app-lite/export/templates/email-export.html';
import ExportHistoryHtml  from './admin-dashboard.export-history.html';
import ExportProductsHtml from './admin-dashboard.export-products.html';

export function ManageExportCtrl ($scope, $window, $q, $translate, $uibModal, $state, workshopAPI, messages) {

  $scope.exportProduct = function () {
    $uibModal.open({
      controller: 'ExportProductsCtrl',
      resolve: {
        company () {
          return $scope.company;
        }
      },
      templateUrl: ExportProductsHtml,
      windowClass: 'sm-modal'
    }).result;
  };

  $scope.exportVehicle = function () {
    workshopAPI.get('/vehicles/vehicle_csv_export_count', $scope.company.id).then(count => {
      if (count) {
        $uibModal.open({
          templateUrl: EmailExportHtml,
          controller: 'emailVehicleExportCtrl',
          windowClass: 'md-modal',
          resolve: {
            company () {
              return $scope.company;
            },
            limited () {
              return false;
            }
          }
        }).result;
      }
      else {
        messages.error($translate.instant('JS_SPACE.MESSAGES.NO_ITEM_TO_EXPORT', { data: $translate.instant('VEHICLE_SPACE.VEHICLES') }), 'error');
        return $q.reject();
      };
    });
  };

  $scope.exportCustomer = function () {
    workshopAPI.get('/customers/customer_csv_export_count', $scope.company.id).then(count => {
      if (count) {
        $uibModal.open({
          templateUrl: EmailExportHtml,
          controller: 'emailCustomerExportCtrl',
          windowClass: 'md-modal',
          resolve: {
            company () {
              return $scope.company;
            },
            limited () {
              return false;
            }
          }
        }).result;
      }
      else {
        messages.error($translate.instant('JS_SPACE.MESSAGES.NO_ITEM_TO_EXPORT', { data: $translate.instant('CUSTOMER_SPACE.CUSTOMERS') }), 'error');
        return $q.reject();
      };
    });
  };

  $scope.exportVendor = function () {
    workshopAPI.get('/vendors/vendor_csv_export_count', $scope.company.id).then(count => {
      if (count) {
        $uibModal.open({
          templateUrl: EmailExportHtml,
          controller: 'emailVendorExportCtrl',
          windowClass: 'md-modal',
          resolve: {
            company () {
              return $scope.company;
            },
            limited () {
              return false;
            }
          }
        }).result;
      }
      else {
        messages.error($translate.instant('JS_SPACE.MESSAGES.NO_ITEM_TO_EXPORT', { data: $translate.instant('VENDOR_SPACE.SUPPLIERS') }), 'error');
        return $q.reject();
      };
    });
  };

  $scope.exportHistory = function () {
    $uibModal.open({
      controller: 'exportHistoryCtrl',
      resolve: {
        company () {
          return $scope.company;
        }
      },
      templateUrl: ExportHistoryHtml,
      windowClass: 'sm-modal'
    }).result;

  };

  $scope.exportHistoryItem = function () {
    $uibModal.open({
      controller: 'exportHistoryItemCtrl',
      resolve: {
        company () {
          return $scope.company;
        }
      },
      templateUrl: ExportHistoryHtml,
      windowClass: 'sm-modal'
    }).result;
  };
}